import { createAction } from "redux-act";

export const OpenTerminateTargetModalAction = createAction("Terminate Target - Open Modal");
export const CloseTerminateTargetModalAction = createAction("Terminate Target - Close Modal");
